var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenbm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_307_1173",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_307_1173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.25 24.9166V7.58325C3.25 6.98742 3.46197 6.47753 3.88592 6.05358C4.31058 5.62892 4.82083 5.41658 5.41667 5.41658H16.25C16.8458 5.41658 17.3561 5.62892 17.7808 6.05358C18.2047 6.47753 18.4167 6.98742 18.4167 7.58325V24.9166L10.8333 21.6666L3.25 24.9166ZM20.5833 21.6666V3.24992H6.5V1.08325H20.5833C21.1792 1.08325 21.6894 1.29522 22.1141 1.71917C22.538 2.14384 22.75 2.65409 22.75 3.24992V21.6666H20.5833Z",
    fill: "#47C87A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenbm);
export default __webpack_public_path__ + "static/media/greenbm.09768b5ad443057facd76b104812f7f8.svg";
export { ForwardRef as ReactComponent };